/*
 * @Description: 有子类，无头图
 * @Author: ywj
 * @Date: 2025-02-07 11:04:44
 * @LastEditTime: 2025-04-07 17:50:13
 * @LastEditors: ywj@originqc.com
 */
import React, { useState } from 'react'
import CustomTitle from '@/components/custom-title';
import GoMore from '@/components/more';
import MiniTab from '@/components/tab';
import Card from '@/components/card'
import leftBg from '../imgs/leftBg.png';
import { goodsData } from '../../config'
import './index.scss';

interface IGoods {
  // title: string,
  isTab: string,//more显示更多，tab,tab切换标签1，标签2
  goodsData: any,
  data: any,

}

const showType = ['coming', 'halfMore', 'more']
const NoHeadGoods: React.FC<IGoods> = (props) => {
  const { isTab, goodsData, data } = props;

  const [tabId, setTabId] = useState<number>(props.goodsData![0]?.id);
 
 


  return (
    <>
      <div className="goods-top">
        <CustomTitle title={data?.name} />{isTab === 'more' ? <GoMore data={ data} /> : <MiniTab data={goodsData} setTabId={setTabId} />}
      </div>
      <div className="goods-box">
          {goodsData?.find((cat: any) => cat.id === tabId)?.products?.map((item: any) => {
            return (
              <React.Fragment key={ item.id}>
              <Card
                {...item}
                goodsData={goodsData?.find((cat: any) => cat.id === tabId)?.products}
                is_list="home"
                tabId={tabId}
                data={data}
                width={295}
                />
                </React.Fragment>
            )

          })}
        

      </div>
    </>
  )
}

export default NoHeadGoods;